var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiconSwitchpoe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 7.75,
    width: 24.5,
    height: 16.5,
    stroke: "#A1A1A1",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13L8.5 14.4434L8.5 11.5566L6 13ZM12 12.75L8.25 12.75L8.25 13.25L12 13.25L12 12.75Z",
    fill: "#A1A1A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17L8.5 18.4434L8.5 15.5566L6 17ZM12 16.75L8.25 16.75L8.25 17.25L12 17.25L12 16.75Z",
    fill: "#A1A1A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15L23.5 13.5566L23.5 16.4434L26 15ZM23.75 14.75L20 14.75L20 15.25L23.75 15.25L23.75 14.75Z",
    fill: "#A1A1A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26 19L23.5 17.5566L23.5 20.4434L26 19ZM23.75 18.75L20 18.75L20 19.25L23.75 19.25L23.75 18.75Z",
    fill: "#A1A1A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12V16.4H15.2V20L18 15.2H16.4L17.6 12H14Z",
    fill: "#73B8FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiconSwitchpoe);
export default __webpack_public_path__ + "static/media/dicon_switchpoe.ed642973782e5127281fe0c313c52469.svg";
export { ForwardRef as ReactComponent };